/**
 * Typed wrapper over `sessionStorage`. Per r365 rules localStorage is forbidden.
 * Values are JSON-serialized. Returns `null` on missing / corrupt entries.
 */
export const sessionGet = <T>(key: string): T | null => {
  if (typeof window === "undefined") return null;
  const raw = window.sessionStorage.getItem(key);
  if (raw === null) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
};

export const sessionSet = <T>(key: string, value: T): void => {
  if (typeof window === "undefined") return;
  window.sessionStorage.setItem(key, JSON.stringify(value));
};

export const sessionRemove = (key: string): void => {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem(key);
};
